module.exports = __webpack_public_path__ + "img/zeno-1.e883b676.jpg";